<template>
    <div class="card">
        <div class="card-header d-flex">
            <h5 class="card-title mb-0">Aviso legal - Banco Itaú</h5>
        </div>
        <div class="card-body">
            <span class="card-text mb-3">
            Este estabelecimento é um Correspondente prestador de serviços do Itaú&#44;
            conforme a Resolução 4.935/2021 do Conselho Monetário Nacional&#44; e está
            autorizado a realizar serviços de pagamentos de boletos&#44; faturas de concessionárias
            e tributos municipais e estaduais com código de barras. Para contato com o Itaú&#44;
            ligue para o SAC: 0800 728 0728&#44; opções 3 e 8&#44; disponível 24 horas por dia.
            Caso não fique satisfeito com a solução apresentada&#44;
            contate a ouvidoria: 0800 570 0011&#44; em dias úteis&#44; das 9h às 18h.
            </span>
            <button class="btn btn-md btn-orange" @click="closePopup">Prosseguir</button>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'PaymentProviderLegalPlate',
    methods: {
      closePopup() {
        sessionStorage.setItem('providerLegalPlateConfirmation', 'true');
        this.$emit('hideLegalPlate', true);
      },
    },
  };
</script>
<style scoped>
  .popup-card {
    z-index: 1050;
    width: 100%;
  }
  .card {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid rgba(0,0,0,.125);
    text-align: center;
    flex-direction: column;
  }
  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-bottom: 0 !important;
  }
  .card-text{
    font-size: 15px;
    font-weight: bold;
    text-align: justify;
  }
</style>
